module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.27.7b7cd984.jpg";